import { render, staticRenderFns } from "./ListTabWebpart.vue?vue&type=template&id=3a2a3adf"
import script from "./ListTabWebpart.ts?vue&type=script&lang=ts&external"
export * from "./ListTabWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports